/* tslint:disable */
/* eslint-disable */
/* @relayHash 996a72adfcf44b91f00726b105f2fa7b */

import { ConcreteRequest } from "relay-runtime";
export type BookingDelegatePickerQueryVariables = {
    text?: string | null;
};
export type BookingDelegatePickerQueryResponse = {
    readonly delegates: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly TTC_ID: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly email: string | null;
            readonly profileImageUrl: string | null;
        } | null> | null;
    } | null;
};
export type BookingDelegatePickerQuery = {
    readonly response: BookingDelegatePickerQueryResponse;
    readonly variables: BookingDelegatePickerQueryVariables;
};



/*
query BookingDelegatePickerQuery(
  $text: String
) {
  delegates(filter: {name: $text}, page: {limit: 20}) {
    edges {
      uuid
      TTC_ID
      firstName
      lastName
      email
      profileImageUrl
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "text",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "delegates",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "text"
                        }
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "page",
                    "value": {
                        "limit": 20
                    }
                }
            ],
            "concreteType": "DelegatePage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uuid",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "TTC_ID",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "profileImageUrl",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "BookingDelegatePickerQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "BookingDelegatePickerQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "BookingDelegatePickerQuery",
            "id": null,
            "text": "query BookingDelegatePickerQuery(\n  $text: String\n) {\n  delegates(filter: {name: $text}, page: {limit: 20}) {\n    edges {\n      uuid\n      TTC_ID\n      firstName\n      lastName\n      email\n      profileImageUrl\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '625e8318be87469ecbbfccb09d2ac364';
export default node;
